import api from "../atlasApi";

export const serviceGetProjects = (data, token) => {
  return api.post("/horizon/get-project/", data, {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceCreateOrEditProjects = (data, token) => {
  return api.post("/horizon/add-edit-project/", data, {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceCalculateProjectCost = (data, token) => {
  return api.post("/horizon/calculate-project-cost/", data, {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "multipart/form-data",
    },
  });
};

